import { action } from "typesafe-actions";
import {
  IAgencyBillReconciliation,
  IReconciliationAgencyBill,
  IReconciliationCustomerPayableBill,
  IReconciliationDirectBill,
  IReconciliationDuplicateItem,
} from "./reconciliation.types";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { generateAdvanceFilterQuery } from "../Accounting/AccountingReports/AccountingReportsActions";

export const FETCH_RECON_AGENCY_BILL_LIST_PROGRESS =
  "FETCH_RECON_AGENCY_BILL_LIST_PROGRESS";
export const FETCH_RECON_AGENCY_BILL_LIST_SUCCESS =
  "FETCH_RECON_AGENCY_BILL_LIST_SUCCESS";
export const FETCH_RECON_AGENCY_BILL_LIST_FAILED =
  "FETCH_RECON_AGENCY_BILL_LIST_FAILED";

export const fetchReconAgencyBillListProgress = () =>
  action(FETCH_RECON_AGENCY_BILL_LIST_PROGRESS);
export const fetchReconAgencyBillListSuccess = (
  data: IReconciliationAgencyBill[],
  totalRecords: number
) => action(FETCH_RECON_AGENCY_BILL_LIST_SUCCESS, { data, totalRecords });
export const fetchReconAgencyBillListFailed = () =>
  action(FETCH_RECON_AGENCY_BILL_LIST_FAILED);

export const fetchReconAgencyBillListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { from_date, to_date, name, ...rest } = searchState;
      const query = generateAdvanceFilterQuery(rest);
      dispatch(fetchReconAgencyBillListProgress());
      let url = "";
      if (status !== "-1") {
        url = "&status=" + status;
      }

      let finalUrl = `/accounting/get-account-invoice-payment-transaction-items?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}${url}`;

      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-account-invoice-payment-transaction-items?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&advanceFilter=${JSON.stringify(
          searchValue
        )}`;
      }
      if (query) {
        finalUrl += "&" + query;
      }

      if (from_date) {
        const filterObj = {
          column: ["date"],
          operator: "GREATER_THAN_EQUAL",
          value: from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (to_date) {
        const filterObj = {
          column: ["date"],
          operator: "LESSER_THAN_EQUAL",
          value: to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      if (name) {
        const filterObj = {
          column: ["name"],
          operator: "CONTAINS",
          value: name,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      const res = await api.get(finalUrl);
      const data: IReconciliationAgencyBill[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      dispatch(fetchReconAgencyBillListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchReconAgencyBillListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_AGENCY_BILL_RECONCILIATION_LIST_PROGRESS =
  "FETCH_AGENCY_BILL_RECONCILIATION_LIST_PROGRESS";
export const FETCH_AGENCY_BILL_RECONCILIATION_LIST_SUCCESS =
  "FETCH_AGENCY_BILL_RECONCILIATION_LIST_SUCCESS";
export const FETCH_AGENCY_BILL_RECONCILIATION_LIST_FAILED =
  "FETCH_AGENCY_BILL_RECONCILIATION_LIST_FAILED";

export const fetchAgencyBillReconciliationListProgress = () =>
  action(FETCH_AGENCY_BILL_RECONCILIATION_LIST_PROGRESS);
export const fetchAgencyBillReconciliationListSuccess = (
  data: IAgencyBillReconciliation[]
) => action(FETCH_AGENCY_BILL_RECONCILIATION_LIST_SUCCESS, { data });
export const fetchAgencyBillReconciliationListFailed = () =>
  action(FETCH_AGENCY_BILL_RECONCILIATION_LIST_FAILED);

export const fetchAgencyBillReconciliationListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    searchState: { [key: string]: any },
    orderBy?: string[]
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAgencyBillReconciliationListProgress());

      const { transaction_from_date, transaction_to_date, policy_number,duplicate_indicator,excludeZeroPremium, ...rest } =
        searchState;

         const query = generateAdvanceFilterQuery(
        rest,
      );


      let url = "";
      if (status !== "-1") {
        url = "&status=" + status;
      }

      if (orderBy && orderBy.length > 0 && orderBy[0] !== "-1") {
        url = "&order_by=" + JSON.stringify(orderBy);
      }



      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        url += `&advanceFilter=${encodedFilter}&`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        url += `advanceFilter=${encodedFilter}&`;
      }

    

      if ( policy_number ) {
        const filterObj = {
          column: ["policy_number"],
          operator: "CONTAINS",
          value: policy_number,
          logicalOperator: "AND",
        };
        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        url += `&advanceFilter=${encodedFilter}`;
      }

      let finalUrl = `/accounting/get-account-invoice-transaction-items?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}${url}`;//&from_date=${date.fromDate}&to_date=${date.toDate}${url}

      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-account-invoice-transaction-items?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&advanceFilter=${JSON.stringify(
          searchValue
        )}`;
      }
      if(duplicate_indicator){
        finalUrl= finalUrl+`&duplicate_indicator=${duplicate_indicator}`;
      }
        if(excludeZeroPremium){
        finalUrl= finalUrl+`&excludeZeroPremium=${excludeZeroPremium}`;
      }

      if (query) {
        finalUrl = finalUrl+"&"+ query;
      }

      const res = await api.get(finalUrl);
      const data: IAgencyBillReconciliation[] = res.data.data;
      dispatch(fetchAgencyBillReconciliationListSuccess(data));
    } catch (err: any) {
      dispatch(fetchAgencyBillReconciliationListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_RECON_DIRECT_BILL_LIST_PROGRESS =
  "FETCH_RECON_DIRECT_BILL_LIST_PROGRESS";
export const FETCH_RECON_DIRECT_BILL_LIST_SUCCESS =
  "FETCH_RECON_DIRECT_BILL_LIST_SUCCESS";
export const FETCH_RECON_DIRECT_BILL_LIST_FAILED =
  "FETCH_RECON_DIRECT_BILL_LIST_FAILED";

export const fetchReconDirectBillListProgress = () =>
  action(FETCH_RECON_DIRECT_BILL_LIST_PROGRESS);
export const fetchReconDirectBillListSuccess = (
  data: IReconciliationDirectBill[],
  totalRecords: number
) => action(FETCH_RECON_DIRECT_BILL_LIST_SUCCESS, { data, totalRecords });
export const fetchReconDirectBillListFailed = () =>
  action(FETCH_RECON_DIRECT_BILL_LIST_FAILED);

export const fetchReconDirectBillListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { from_date, to_date, name, ...rest } = searchState;
      const query = generateAdvanceFilterQuery(rest);
      dispatch(fetchReconDirectBillListProgress());
      let url = "";
      if (status !== "-1") {
        url = "&status=" + status;
      }

      let finalUrl = `/accounting/get-account-create-payment?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}${url}`;

      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-account-create-payment?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&advanceFilter=${JSON.stringify(
          searchValue
        )}`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      if (from_date) {
        const filterObj = {
          column: ["payment_date"],
          operator: "GREATER_THAN_EQUAL",
          value: from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (to_date) {
        const filterObj = {
          column: ["payment_date"],
          operator: "LESSER_THAN_EQUAL",
          value: to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }

      if (name) {
        const filterObj = {
          column: ["name"],
          operator: "CONTAINS",
          value: name,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      const res = await api.get(finalUrl);
      const data: IReconciliationDirectBill[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      dispatch(fetchReconDirectBillListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchReconDirectBillListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_RECON_CUSTOMER_PAYABLE_LIST_PROGRESS =
  "FETCH_RECON_CUSTOMER_PAYABLE_LIST_PROGRESS";
export const FETCH_RECON_CUSTOMER_PAYABLE_LIST_SUCCESS =
  "FETCH_RECON_CUSTOMER_PAYABLE_LIST_SUCCESS";
export const FETCH_RECON_CUSTOMER_PAYABLE_LIST_FAILED =
  "FETCH_RECON_CUSTOMER_PAYABLE_LIST_FAILED";

export const fetchCustomerPayableListProgress = () =>
  action(FETCH_RECON_CUSTOMER_PAYABLE_LIST_PROGRESS);
export const fetchCustomerPayableListSuccess = (
  data: IReconciliationCustomerPayableBill[],
  totalRecords: number
) => action(FETCH_RECON_CUSTOMER_PAYABLE_LIST_SUCCESS, { data, totalRecords });
export const fetchCustomerPayableListFailed = () =>
  action(FETCH_RECON_CUSTOMER_PAYABLE_LIST_FAILED);

export const fetchCustomerPayableListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchCustomerPayableListProgress());
      let url = "";
      if (status !== "-1") {
        url = "&status=" + status;
      }

      let finalUrl = `/accounting/get-account-bill-payment-transaction-items?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}${url}`;

      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-account-bill-payment-transaction-items?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&advanceFilter=${JSON.stringify(
          searchValue
        )}`;
      }
      const res = await api.get(finalUrl);
      const data: IReconciliationCustomerPayableBill[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      dispatch(fetchCustomerPayableListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchCustomerPayableListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

/**-- */
export const FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_PROGRESS =
  "FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_PROGRESS";
export const FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_SUCCESS =
  "FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_SUCCESS";
export const FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_FAILED =
  "FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_FAILED";

export const fetchDuplicateTransactionsItemsListProgress = () =>
  action(FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_PROGRESS);
export const fetchDuplicateTransactionsItemsListSuccess = (
  data: IReconciliationDuplicateItem[]
) => action(FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_SUCCESS, { data });
export const fetchDuplicateTransactionsItemsListFailed = () =>
  action(FETCH_DUPLICATE_TRANSACTION_ITEMS_LIST_FAILED);

export const fetchDuplicateTransactionsItemsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    searchState: { [key: string]: any },
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchDuplicateTransactionsItemsListProgress());

      const {
        from_date,
        to_date,
        insurer_code,
        branch_code,
        producer_one_code,
        reconciled,
        premium,
        order_by,
        policy_number,
      } = searchState;

      let finalUrl = `/accounting/get-duplicate-invoice-transaction-items?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}`;

      if (searchValue.length > 0) {
        finalUrl = finalUrl + `&advanceFilter=${JSON.stringify(searchValue)}`;
      }

      if (from_date) {
        finalUrl = finalUrl + "&from_date=" + from_date;
      }

      if (to_date) {
        finalUrl = finalUrl + "&to_date=" + to_date;
      }

      if (insurer_code) {
        finalUrl = finalUrl + "&insurer_code=" + insurer_code;
      }

      if (branch_code) {
        finalUrl = finalUrl + "&branch_code=" + branch_code;
      }

      if (branch_code) {
        finalUrl = finalUrl + "&branch_code=" + branch_code;
      }

      if (producer_one_code) {
        finalUrl = finalUrl + "&producer_one_code=" + producer_one_code;
      }

      if (reconciled) {
        finalUrl = finalUrl + "&reconciled=" + reconciled;
      }

      if (premium) {
        finalUrl = finalUrl + "&exclude_zero_amount=" + premium;
      }

      if (order_by) {
        finalUrl = finalUrl + "&order_by=" + order_by;
      }

      if (policy_number) {
        finalUrl = finalUrl + "&policy_number=" + policy_number;
      }

      const res = await api.get(finalUrl);
      const data: IReconciliationDuplicateItem[] = res.data.data;
      dispatch(fetchDuplicateTransactionsItemsListSuccess(data));
    } catch (err: any) {
      dispatch(fetchDuplicateTransactionsItemsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };



export const deleteTransactionsItemsListAsync =
  (
    primary_ids: number[],
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      const finalUrl = `/accounting/delete-transaction-items?table_name=accn_invoice_transaction_items`;

      await api.put(finalUrl, {
        table_name: "accn_invoice_transaction_items",
        primary_id: primary_ids,
        deleted_record: 1,
      });
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const UPDATE_INVOICE_PAYMENT_TRANSACTION_RECONCILIATION_STATUS =
  "UPDATE_INVOICE_PAYMENT_TRANSACTION_RECONCILIATION_STATUS";
export const updateInvoicePaymentTransactionReconciliationStatusAsync = (
  paymentIds: number[],
  reconciled: string,
  reconciledDate: string
) =>
  action(UPDATE_INVOICE_PAYMENT_TRANSACTION_RECONCILIATION_STATUS, {
    paymentIds,
    reconciled,
    reconciledDate,
  });

export const updateReconciledStatusofInvoicePaymentTransaction =
  (
    data: {
      payment_id: number[];
      reconciled: string;
      reconciled_date: string | null;
    },
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.put("/accounting/update-reconciliation-status", {
        type: "invoice_payments_items",
        primary_id: data.payment_id,
        reconciled: data.reconciled,
        reconciled_date: data.reconciled_date,
      });
      const message = "Bill reconciled successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      dispatch(
        updateInvoicePaymentTransactionReconciliationStatusAsync(
          data.payment_id,
          data.reconciled,
          data.reconciled_date as string
        )
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const UPDATE_BILL_PAYMENT_RECONCILIATION_STATUS =
  "UPDATE_BILL_PAYMENT_RECONCILIATION_STATUS";
export const updateBillPaymentReconciliationStatus = (
  payment_id: number[],
  reconciled: string,
  reconciledDate: string
) =>
  action(UPDATE_BILL_PAYMENT_RECONCILIATION_STATUS, {
    payment_id,
    reconciled,
    reconciledDate,
  });

export const updateReconciledStatusofCreateBillPayment =
  (
    data: {
      payment_id: number[];
      reconciled: string;
      reconciled_date: string | null;
    },
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.put("/accounting/update-reconciliation-status", {
        type: "bill_payments",
        primary_id: data.payment_id,
        reconciled: data.reconciled,
        reconciled_date: data.reconciled_date,
      });
      const message = "Bill reconciled successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      dispatch(
        updateBillPaymentReconciliationStatus(
          data.payment_id,
          data.reconciled,
          data.reconciled_date as string
        )
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_RECONCILIATION_STATE = "CLEAR_RECONCILIATION_STATE";
export const clearReconciliationState = () =>
  action(CLEAR_RECONCILIATION_STATE);
